import store from './storage'



export function setToken (info) {
  store.set('TOKEN_KEY', info)
  return info
}

export function getToken () {
  return store.get('TOKEN_KEY')
}

export function setUserInfo (info) {
  store.set('USER_KEY', info)
  return info
}

export function getUserInfo () {
  return store.get('USER_KEY')
}
export function getMenusone () {
  let menus
  try {
    menus = store.get('MENU_KEY')
  } catch (e) {
    menus = []
  }
  return menus || []
}
// 保存菜单
export function setMenusone (info) {
  store.set('MENU_KEY', info)
  return info
}

export function removeToken () {
  store.remove('TOKEN_KEY')
  store.remove('USER_KEY')
  store.remove('MENU_KEY')
}



// WEBPACK FOOTER //
// ./src/utils/auth.js